var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showExamples)?_c('div',[_c('router-view')],1):_c('div',{attrs:{"id":"app"}},[_c('app-menu'),_c('div',{staticClass:"container"},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }